
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore } from "@/store/store";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";

type Shortcut = {
  shortcut: (keyof typeof KEYBOARD_SHORTCUTS)[];
  description: string;
  availableIn: ("breakdance" | "oxygen")[];
};

@Component({
  components: {}
})
export default class KeyboardShortcutsHelpModal extends Vue {
  @Prop()
  open!: boolean;

  shortcuts: Shortcut[] = [
    {
      shortcut: ["CMD_A"],
      description: "Open add elements panel",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_B"],
      description: "Open design sets modal",
      availableIn: ["breakdance"]
    },
    {
      shortcut: ["CMD_S"],
      description: "Save",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_Z"],
      description: "Undo",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_SHIFT_Z"],
      description: "Redo",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_C"],
      description: "Copy the active element",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_V"],
      description: "Paste copied element",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_D"],
      description: "Duplicate the active element",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["ESC"],
      description: "De-activate the active element or close modal",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["SHIFT_ESC"],
      description: "Go to the parent of the active element",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["BACKSPACE", "DELETE"],
      description: "Delete active element",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_OPTION_R"],
      description: "Cycle to the next breakpoint",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_SHIFT_SLASH", "CMD_QUESTION"],
      description: "Show keyboard shortcuts help modal",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_SHIFT_S"],
      description: "Switch between 'scale to fit' and 'actual size' content",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["CMD_E"],
      description:
        "Open the rich text editor modal. Only when the Rich Text element is selected",
      availableIn: ["breakdance", "oxygen"]
    },
    {
      shortcut: ["C_S_S"],
      description:
        "Open the active element's Advanced → Custom CSS and focus it.",
      availableIn: ["breakdance"]
    },
    {
      shortcut: ["C_L_A"],
      description:
        "Open the active element's Advanced → Classes autocomplete and focus it.",
      availableIn: ["breakdance"]
    },
    {
      shortcut: ["F"],
      description: "Focus the properties search box.",
      availableIn: ["breakdance"]
    },
    {
      shortcut: ["SHIFT_F"],
      description:
        "Focus the properties search box and toggle the option to search advanced settings (element properties panel only).",
      availableIn: ["breakdance"]
    },
    {
      shortcut: ["CMD_I"],
      description: "Toggle the modified option in the properties search box.",
      availableIn: ["breakdance"]
    },
    {
      shortcut: ["OPTION_P"],
      description: "Toggle the preview mode.",
      availableIn: ["breakdance", "oxygen"]
    }
  ];

  get builderMode() {
    return configStore.builderMode || "breakdance";
  }

  get filteredShortcuts() {
    return this.shortcuts
      .filter(item => item.availableIn.includes(this.builderMode))
      .map(item => {
        const shortcut = item.shortcut
          .map(this.getKeyboardShortcutValue)
          .join("<br />");

        return {
          ...item,
          shortcut
        };
      });
  }

  getKeyboardShortcutValue(shortcut: keyof typeof KEYBOARD_SHORTCUTS) {
    const keys = KEYBOARD_SHORTCUTS[shortcut];
    const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    let keyCombo = keys ? keys[0] : "";
    if (!isMacLike && keys.length == 2) {
      keyCombo = keys[1];
    }

    return keyCombo.toUpperCase().split("+").join(" + ");
  }
}
